export const GET_COMPANY_INFO = {
  START: 'GET_COMPANY_INFO_START',
  SUCCESS: 'GET_COMPANY_INFO_SUCCESS',
  ERROR: 'GET_COMPANY_INFO_ERROR',
};

export const EDIT_COMPANY_INFO = {
  START: 'EDIT_COMPANY_INFO_START',
  SUCCESS: 'EDIT_COMPANY_INFO_SUCCESS',
  ERROR: 'EDIT_COMPANY_INFO_ERROR',
};
